export default "__VITE_ASSET__Wnw501rp__"